import React, { useState } from "react";
import { Box, Typography, Button, Input } from "@mui/material";
import { submitAnswer } from "../../services/programService";
import { AudioRecorder } from "react-audio-voice-recorder";

interface TranscriptionFeedback {
  feedback: {
    comment: string;
    score: number;
  };
  transcription: string;
}
const Speaking: React.FC = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [feedback, setFeedback] = useState<TranscriptionFeedback | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      setFeedback(null);
      // Call the submitAnswer function
      const result = await submitAnswer("1", "quiestion-id", formData);

      setFeedback(result.data);
      console.log("Transcription:", result.data);
    } catch (error) {
      setFeedback(null);
      console.error("Error during audio processing:", error);
    }
  };

  // Function to handle the audio file after recording is complete
  const handleRecordingComplete = async (audioBlob: Blob) => {
    try {
      setFeedback(null);
      const formData = new FormData();
      formData.append("file", audioBlob, "audio.webm");

      const result = await submitAnswer("1", "quiestion-id", formData);
      setFeedback(result.data);
      console.log("Transcription:", result.data);
    } catch (error) {
      setFeedback(null);
      console.error("Error during audio processing:", error);
    }
  };

  return (
    <>
      {/* <Box sx={{ padding: 2 }}>
        <Typography variant="h5" gutterBottom>
          Upload Your Speaking Test
        </Typography>
        <Input
          type="file"
          inputProps={{ accept: "audio/*" }}
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleFileUpload}
          disabled={!selectedFile}
          sx={{ mt: 2 }}
        >
          Upload Audio
        </Button>
      </Box> */}
      <Typography variant="h4" gutterBottom>
        {" "}
        Yes, that sounds ideal, but it is not always possible now, is it?
      </Typography>

      <Box sx={{ padding: 2 }}>
        <Typography variant="body1" gutterBottom>
          Record Your Speaking Test, say the sentence above
        </Typography>
        <AudioRecorder
          onRecordingComplete={handleRecordingComplete}
          audioTrackConstraints={{
            noiseSuppression: true,
            echoCancellation: true,
          }}
          downloadOnSavePress={false}
          downloadFileExtension="webm"
        />
      </Box>

      <Box sx={{ padding: 2 }}>
        <Typography variant="body1" gutterBottom>
          {" "}
          Your transcription:{feedback?.transcription}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Feedback:{feedback?.feedback.comment}
        </Typography>

        <Typography variant="body1" gutterBottom>
          {" "}
          Score:{feedback?.feedback.score}
        </Typography>
      </Box>
    </>
  );
};

export default Speaking;
/**
 * return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>
        Record Your Speaking Test
      </Typography>
      <AudioRecorder
        onRecordingComplete={handleRecordingComplete}
        audioTrackConstraints={{
          noiseSuppression: true,
          echoCancellation: true,
        }}
        downloadOnSavePress={false}
        downloadFileExtension="webm"
      />
    </Box>
  );
};
 */
